import clsx from 'clsx';
import { ChildType, RowSize } from './consts';
import type { TeaserListProps } from './interfaces';
import styles from './TeaserList.module.scss';

const TeaserList = ({
  children,
  rowSize = RowSize.Three,
  childType = ChildType.Default,
}: TeaserListProps) => {
  const className = clsx(styles[rowSize], styles[childType], styles.base);
  return <div className={className}> {children} </div>;
};

export default TeaserList;
